import React from 'react';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE, RedcatIconProps } from './RedcatIcon';

const RedcatAdjustPinMoveMapIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 32 32`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 6.66667V3.4L3.4 11.3333H6.66667V13.3333H0V6.66667H2V9.93333L9.93333 2H6.66667V0H13.3333V6.66667H11.3333Z"
        fill={color}
      />
      <path
        d="M18.4103 17.4033V8.45598C18.4103 7.98138 18.2185 7.52622 17.8771 7.19063C17.5357 6.85504 17.0726 6.6665 16.5898 6.6665C16.1069 6.6665 15.6439 6.85504 15.3025 7.19063C14.961 7.52622 14.7692 7.98138 14.7692 8.45598V18.5963L12.9851 16.8426C12.6277 16.4918 12.1613 16.2683 11.66 16.2078C11.1586 16.1473 10.651 16.2532 10.2179 16.5086C9.81126 16.7483 9.51577 17.1344 9.39428 17.5849C9.27279 18.0353 9.33489 18.5146 9.56737 18.9208C11.8479 22.9054 13.1769 25.1828 13.5556 25.7542L13.7934 26.1121C14.4567 27.1021 15.3598 27.9147 16.4215 28.4769C17.4833 29.0392 18.6704 29.3334 19.8764 29.3332H19.624H22.0514C23.9827 29.3332 25.8349 28.579 27.2006 27.2367C28.5663 25.8943 29.3335 24.0737 29.3335 22.1753V16.8069C29.3335 16.3323 29.1417 15.8771 28.8003 15.5415C28.4589 15.2059 27.9958 15.0174 27.513 15.0174C27.0301 15.0174 26.5671 15.2059 26.2257 15.5415C25.8842 15.8771 25.6924 16.3323 25.6924 16.8069M18.4103 16.8069V14.4209C18.4103 13.9463 18.6021 13.4911 18.9435 13.1555C19.2849 12.8199 19.748 12.6314 20.2308 12.6314C20.7137 12.6314 21.1767 12.8199 21.5181 13.1555C21.8596 13.4911 22.0514 13.9463 22.0514 14.4209V17.4033M22.0514 15.6139C22.0514 15.1393 22.2432 14.6841 22.5846 14.3485C22.926 14.0129 23.3891 13.8244 23.8719 13.8244C24.3547 13.8244 24.8178 14.0129 25.1592 14.3485C25.5006 14.6841 25.6924 15.1393 25.6924 15.6139V17.4033"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedcatAdjustPinMoveMapIcon;
